/**
 * Analytics Module Entry Point
 * 
 * Provides pre-configured singleton instance of AnalyticsBus
 * with Facebook, TikTok, and GTM plugins pre-registered.
 */

import { AnalyticsBus } from './bus';
import { FacebookPlugin } from './plugins/facebookPlugin';
import { TikTokPlugin } from './plugins/tiktokPlugin';
import { GtmPlugin } from './plugins/gtmPlugin';

export * from './types';
export * from './bus';
export * from './plugins/facebookPlugin';
export * from './plugins/tiktokPlugin';
export * from './plugins/gtmPlugin';

// Create and configure default singleton instance
export const analytics = new AnalyticsBus();
analytics.registerPlugin(new FacebookPlugin());
analytics.registerPlugin(new TikTokPlugin());
analytics.registerPlugin(new GtmPlugin());

// Convenience shortcut methods
export const trackEvent = (eventName: string, data?: Record<string, any>) => analytics.track(eventName, data);
export const trackViewContent = (product: Parameters<AnalyticsBus['viewContent']>[0]) => analytics.viewContent(product);
export const trackAddToCart = (product: Parameters<AnalyticsBus['addToCart']>[0]) => analytics.addToCart(product);
export const trackInitiateCheckout = (items: Parameters<AnalyticsBus['initiateCheckout']>[0], total: number) => analytics.initiateCheckout(items, total);
export const trackPurchase = (order: Parameters<AnalyticsBus['purchase']>[0]) => analytics.purchase(order);

export default analytics;
